// Sprint 6-organs §6.2 — плитка органа в разрезе «По органам».
// Цвет — по headline_status через общий displayTier-словарь (не второй словарь).
// Копирайт §0: название органа + «X из Y показателей» + фактический счёт статусов
// («3 в норме, 1 требует внимания»), НЕ балл/оценка. Pure presentational.

import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { STRIPE_BY_TIER } from '@/lib/biomarkerStatus';
import { StatusGlyph } from '@/components/dashboard/StatusGlyph';
import {
  organMarkersCountLabel,
  organStatusToTier,
  statusCountsSummary,
} from '@/lib/organView';
import { organLabelFor } from '@/lib/organ-taxonomy';
import type { OrganSummary } from '@/api/types';

export function OrganTile({
  organ,
  onClick,
}: {
  organ: OrganSummary;
  onClick: () => void;
}) {
  const tier = organStatusToTier(organ.headline_status);
  const label = organ.organ_label_ru || organLabelFor(organ.organ_code);
  const summary = statusCountsSummary(organ.status_counts);

  return (
    <button
      type="button"
      onClick={onClick}
      className="relative flex w-full items-center gap-3 overflow-hidden rounded-surface border border-border bg-card p-3.5 text-left hover-elevate active-elevate-2"
    >
      <span
        aria-hidden
        className={cn('absolute left-0 top-0 h-full w-1', STRIPE_BY_TIER[tier])}
      />
      {/* D-11: цвет перестал быть единственным носителем статуса. */}
      <StatusGlyph tier={tier} />
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold text-foreground">{label}</div>
        <div className="text-hl-small text-muted-foreground">
          {organMarkersCountLabel(organ.markers_with_data, organ.markers_total)}
        </div>
        {summary && <div className="mt-0.5 text-hl-small text-muted-foreground">{summary}</div>}
      </div>
      <ChevronRight className="h-4 w-4 flex-shrink-0 text-gray-400" aria-hidden="true" />
    </button>
  );
}
